module.exports = __webpack_public_path__ + "img/show_tc_text_5.35586e71.png";